export const appThemes = {
    inkassier: "inkassier",
    invoned: "invoned",
};
